import { MapPin, PhoneCall } from "lucide-react";
import { useState } from "react";

const stateCopy = {
  PA: { label: "Pennsylvania", note: "Serving Chester, Montgomery, Delaware and nearby counties." },
  DE: { label: "Delaware", note: "Serving Northern Delaware and nearby communities." },
  NJ: { label: "New Jersey", note: "Serving South Jersey and nearby communities." },
};

const Coverage = ({ settings }) => {
  const [active, setActive] = useState("PA");
  const areas = settings.service_areas?.[active] || [];
  const phone = settings.phone.replace(/[^0-9+]/g, "");

  return (
    <section className="coverage-section section-wrap" id="coverage" data-testid="coverage-section">
      <div className="coverage-grid">
        <div className="coverage-intro"><p className="eyebrow">Service areas</p><h2>Hardwood floors in PA, DE and NJ.</h2><p>We come to your home for installation, refinishing and repairs.</p><a className="text-link" href={`tel:${phone}`} data-testid="coverage-call-link"><PhoneCall size={17} /> Ask about your area</a></div>
        <div className="coverage-panel">
          <div className="state-tabs" role="tablist" aria-label="Service areas">
            {Object.keys(stateCopy).map((state) => <button type="button" role="tab" aria-selected={active === state} className={active === state ? "state-tab is-active" : "state-tab"} onClick={() => setActive(state)} key={state} data-testid={`service-area-${state.toLowerCase()}-tab`}><span>{state}</span>{stateCopy[state].label}</button>)}
          </div>
          <div className="coverage-detail" data-testid="coverage-area-list"><div className="coverage-detail-heading"><MapPin size={19} /><div><p className="eyebrow">Now serving</p><h3>{stateCopy[active].label}</h3></div></div><p className="coverage-note">{stateCopy[active].note}</p><div className="city-list">{areas.map((city) => <span key={city} data-testid={`service-city-${city.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{city}</span>)}</div></div>
        </div>
      </div>
    </section>
  );
};

export default Coverage;
